import React, { Component } from 'react';
import SearchResults from '../search-results';

class App extends Component {
  render() {
    const { app, env, ga, gaDebug, dev } = this.props;
    return (
      <div>
        <div>
          <SearchResults {...this.props} app={app} env={env} ga={ga} gaDebug={gaDebug} dev={dev} />
        </div>
      </div>
    );
  }
}

export default App;
